import React from "react";

const Services = () => {
  // services details
  const services = [
    {
      name: "Cloud Architecture",
      desc: "Designing highly available, secure, and cost-effective cloud infrastructures across AWS, GCP, and Azure using modern design patterns.",
      icon: "fas fa-cloud",
    },
    {
      name: "DevOps",
      desc: "Building fast, reliable CI/CD pipelines with GitHub Actions, managing scalable build agent fleets and artifact repositories.",
      icon: "fas fa-tools",
    },
    {
      name: "Container Orchestration",
      desc: "Architecting, securing, and maintaining containerized workloads at scale using Kubernetes, Docker, and Helm.",
      icon: "fas fa-cubes",
    },
    {
      name: "Site Reliability Engineering",
      desc: "Implementing observability (logging, metrics, tracing), chaos engineering, and proactive incident response for mission-critical systems.",
      icon: "fas fa-heartbeat",
    },
    {
      name: "Network Engineering",
      desc: "Designing and managing secure network architectures, VPCs, subnets, routing tables, VPNs, and load balancing configurations.",
      icon: "fas fa-network-wired",
    },
    {
      name: "Cloud Engineering",
      desc: "Provisioning and managing scalable infrastructure as code using Terraform, automating resource deployment, and ensuring secure cloud configurations.",
      icon: "fas fa-server",
    }
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        <p className="text-5 fw-300 text-center mb-5 wow fadeInUp">
        I'm currently working as a Senior DevOps Engineer in the Platform team at Xero. 
        I maintain internal production systems that are mission critical for the everyday engineering operations.
        Mainly I look after multiple CI/CD instances including 1000s of their build agents and I take care of multiple artifact repositories.
        </p>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
